import React, { useState, useEffect, useRef } from "react";

import Table from "@mui/material/Table";
import { API } from "aws-amplify";
import config from "../../../config/aws-exports";
import Button from "@mui/material/Button";
// import { styled } from "@mui/system";
// import swal from "sweetalert2";
import swal1 from "@sweetalert/with-react";
// import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
// import Modal from "@mui/material/Modal";
// import Fade from "@mui/material/Fade";
// import Backdrop from "@mui/material/Backdrop";
import { CSVLink } from "react-csv";

import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
//import Paper from "@mui/material/Paper";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import BackDrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { Constants } from "../../../config/Constants";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
//import useMediaQuery from "@mui/material/useMediaQuery";

import { useSelector } from "react-redux";
import { authData } from "../../../redux/auth/authSlice";
//import ProformaEdit from "../ProformaInvoice/ProformaEdit";
// Local imports
import { ReactComponent as Close } from "../../../assets/icons/close_black_24dp.svg";
//import { CustomButton } from "../../CustomButton/CustomButton";
import Feedback from "./Feedback";
import { FileDownload } from "@mui/icons-material";

// Styles imports
import Ap from "./ApproveUsers.module.scss";
import Li from "./ListofUsers.module.scss";
import CertificatePopUp from "./CertificatePopUp";
import { Box } from "@mui/material";
import ProInvoice from "../ProformaInvoice/ProInvoice";
import listTopStyle from "./listTopics.module.scss";
import ThankYouModal from "./ThankyouMail";
import RegistersUsers from "./RegistersUsers";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: "flex",
//     heigth: "100%",
//     alignItems: "center",
//     justifyContent: "center",
//     background: "transparent",
//   },
//   backdrop: { zIndex: theme.zIndex.drawer + 1, color: "#fff" },
// }));

const header = {
  color: "white",
  fontSize: "16px",
  fontWeight: "400px",
};

export default function RegisteredUsers(props) {
  //const classes = useStyles();
  // const theme = useTheme();
  //const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  let { handleCloseList, listForReg, tenantoid, tenant, listSessions } = props;
  const [page, setPage] = useState(0);
  //const [imageExtentionError, setImageExtentionError] = useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [invoiceimg, setInvoiceimg] = useState(null);
  console.log("===", invoiceimg);
  //const [invoiceFileName, setInvoiceFileName] = useState(null);
  // const [certificateimg, setCertificateImg] = useState(null);
  // const [certificateFileName, setCertificateFileName] = useState(null);
  const [registeredUsers, setRegisteredUsers] = useState([]);
  console.log(registeredUsers);
  const [spin, setSpin] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [invoiceOpen, setInvoiceOpen] = useState(false);
  const [viewingState, setViewingState] = useState({});
  const [certificateOpen, setCertificateOpen] = useState(false);
  const [userDetailsReg, setUserDetailsReg] = useState({});
  // const [viewingStatecertificate, setViewingStatecertificate] = useState({});
  const refselectedInvoiceFile = useRef();
  // const refselectedCertificateFile = useRef();
  const [newArray, setNewArray] = useState([]);
  const [feedData, setFeedData] = useState({});
  const [inputValue, setInputValue] = useState([]);
  console.log(inputValue);
  const [showButton] = useState(false);
  let userDetails = useSelector(authData);
  const [openProforma, setOpenProforma] = useState(false);
  const [openProformaEdit] = useState(false);
  const [userInvoiceData, setUserInvoiceData] = useState({});
  //const [AttenSubmitted, setAttenSubmitted] = useState(false);
  //const [actaualAmt, setActualAmt] = useState("");
  //const [actaualAmtUnit, setActualAmtUnit] = useState("");
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showRegisterShowModal, setRegisterShowModal] = useState(false);
  const [showUsersModal, setShowUsersModal] = useState(false);

  const [selectedMailUsers, setSelectedMailUsers] = useState([]);

  // const handleSelectAllMail = (e) => {
  //   if (e.target.checked) {
  //     const allIds = registeredUsers.map(
  //       (item) => item.ur_id.toString()
  //     );
  //     console.log("selectedMailUsers",allIds);
  //     setSelectedMailUsers(allIds);
  //   } else {
  //     setSelectedMailUsers([]);
  //   }
  // };

  // const handleMailRowClick = (e, id) => {

  //   if (e.target.checked) {

  //     setSelectedMailUsers((prev) => [...prev, id]);
  //   } else {

  //     setSelectedMailUsers((prev) =>
  //       prev.filter((item) => item !== id)
  //     );
  //   }
  // };

  function handleOpenProforma(item) {
    setOpenProforma(true);
    setUserInvoiceData(item);
  }

  const handleCloseProforma = () => {
    setOpenProforma(false);
  };
  // const handleOpenProformaEdit = () => {
  //   setOpenProformaEdit(true);
  // };

  // const handleCloseProformaEdit = () => {
  //   setOpenProformaEdit(false);
  // };

  // const Input = styled("input")({
  //   display: "none",
  // });

  useEffect(() => {
    setHeaders([
      { label: "First Namedfdfg", key: "first_name" },
      { label: "Last Name", key: "last_name" },
      { label: "Email", key: "emailid" },
      // { label: "Assigness", key: "assign" },
      { label: "Attendance", key: "attendance" },
      { label: "Actual Amount", key: "actual_amount" },
    ]);

    if (listForReg.paid === true || listForReg.paid === "true") {
      setHeaders((prevHeaders) => [
        ...prevHeaders,
        { label: "Payment Method", key: "paymentstatus" },
      ]);
    }
    getRegisteredUsers();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleViewClick = (item) => {
    console.log(item);
    setViewingState(item);
    setInvoiceOpen(true);
  };

  // const handleViewClickCertificate = (item) => {
  //   setViewingStatecertificate(item);
  //   setCertificateOpen(true);
  // };

  const handleFeedBackOpen = (item) => {
    setFeedbackOpen(true);
    setFeedData(item);
  };

  const handleFeedBackClose = () => {
    setFeedbackOpen(false);
  };

  const handleClickCertificateOpen = (item) => {
    setUserDetailsReg(item);
    setCertificateOpen(true);
  };

  async function getRegisteredUsers() {
    setSpin(true);
    const bodyParam = {
      body: {
        sid: listForReg.sid,
        type: "session",
        oid: config.aws_org_id,
        typeusers: "reg_users",
        tenantoid: tenantoid,
        tenant: tenant,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const reg = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_REGISTERED_USERS,
        bodyParam,
      );
      //  let registeredusers = [];
      /*  for (let i = 0; i < reg.body.length; i++) {
        if (reg.body[i].pstatus !== 10) {
          registeredusers.push(reg.body[i]);
        }
      } */

      setData(funData(reg.body));
      for (let i = 0; i < reg.body.length; i++) {
        reg.body[i].updated_amount = false;
      }
      setRegisteredUsers(reg.body);
      CopyOldAttendence(reg.body);
      setSpin(false);
      //setIstLoading(false);
    } catch (error) {
      // alert(JSON.stringify(error));
      console.error(error);
      setSpin(false);
    }
  }

  const funData = (data) => {
    console.log({ data });
    let datalist = data.map((item) => {
      item.paymentstatus =
        item?.pstatus === 0
          ? "NEFT"
          : item?.pstatus === 1
            ? "RazorPay"
            : item?.pstatus === 2
              ? "Pay Later"
              : "Payment in process";
      item.attendance = item?.attend === 1 ? "Attended" : "Not Attended";
      return item;
    });
    return datalist;
  };
  const getExtension = (filename) => {
    let parts = filename.split(".");
    return parts[parts.length - 1];
  };

  // const isImage = (filename) => {
  //   var ext = getExtension(filename);
  //   switch (ext.toLowerCase()) {
  //     case "jpg":
  //     case "png":
  //     case "jpeg":
  //       return true;
  //     default:
  //       return false;
  //   }
  // };

  const isDoc = (filename) => {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
      case "pdf":
        return true;
      default:
        return false;
    }
  };

  // const handleimage = (event, item) => {
  //   console.log("1", item.ur_id);
  //   if (!isDoc(event.target.files[0].name)) {
  //     swal1("Wrong file format! Accepted file format: .pdf");
  //     return;
  //   }
  //   setImageExtentionError("");
  //   setSpin(true);

  //   setInvoiceimg({ file: event.target.files[0] });
  //   refselectedInvoiceFile.current = event.target.files[0];
  //   console.log("image");
  //   handleimageUpload(event.target.files[0], item);
  // };
  const handleimageRE = (event, item) => {
    if (!isDoc(event.target.files[0].name)) {
      swal1("Wrong file format! Accepted file format: .pdf");
      return;
    }
    // setImageExtentionError("");
    setSpin(true);

    setInvoiceimg({ file: event.target.files[0] });
    refselectedInvoiceFile.current = event.target.files[0];
    handleimageUpload(event.target.files[0], item);
  };

  function handleimageUpload(imageGot, item) {
    if (imageGot == null) {
      return;
    }

    if (imageGot.size > 5242880) {
      swal1(
        "Oops!",
        "File size is too large. File size cannot be greater than 5mb.",
        "error",
      );
      return;
    }
    if (imageGot !== undefined) {
      let uniqueStamp = new Date().getTime();
      let invoiceID = uniqueStamp + ".pdf";
      //setInvoiceFileName(uniqueStamp + ".pdf");

      var body = {
        type: "uploadInvoice",
        oid: config.aws_org_id,
        filetype: imageGot.type,
        filename: invoiceID,
      };

      uploadfile(body, imageGot, invoiceID, item);
    }
  }

  async function uploadfile(body, file, invoiceID, item) {
    //setIstLoading(true);
    const bodyParam = {
      body,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const preSignedData = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_PRESIGNED_URL,
        /* "/getpreSignedURL", */
        bodyParam,
      );

      axios
        .put(preSignedData, file, {
          headers: {
            "Content-Type": file.type,
            "Cache-Control": "no-cache no-store must-revalidate",
          },
        })
        .then((response) => {
          console.log("file upload success");
          uploadInvoice(invoiceID, item);
        })

        .catch((error) => {
          console.error("There was an error!", error);
        });

      //setIstLoading(false);
    } catch (error) {
      // alert(JSON.stringify(error));
      console.error(error);
    }
  }

  async function uploadInvoice(invoiceID, item) {
    //item.invoiceID = invoiceID;
    const bodyParam = {
      body: {
        sid: listForReg.sid,
        ur_id: item.ur_id,
        invoiceID: invoiceID,
        /* uData: item,
        eid: item.eid,
        tenant: item.tenant, */

        oid: config.aws_org_id,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const upload = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.UPLOAD_INVOICE,

        bodyParam,
      );

      console.log("upload", upload);
      refselectedInvoiceFile.current = null;
      getRegisteredUsers();
      setSpin(false);
      swal1("Uploded Sucessfully");
      //setIstLoading(false);
    } catch (error) {
      // alert(JSON.stringify(error));
      swal1("Uploded unsucessfull");
      console.error(error);
      setSpin(false);
    }
  }

  async function updateAttendence(unmark) {
    setSpin(true);
    //item.invoiceID = invoiceID;
    const bodyParam = {
      body: {
        sid: listForReg.sid,
        unmark: unmark,
        mark: newArray,
        oid: config.aws_org_id,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      await API.post(
        config.aws_cloud_logic_custom_name,
        "/markAttendence ",

        bodyParam,
      );

      getRegisteredUsers();
      setSpin(false);
      swal1("Attendence marked Sucessfully");
      //setIstLoading(false);
    } catch (error) {
      // alert(JSON.stringify(error));

      setSpin(false);
    }
  }

  // const handleimageCertificate = (event, item) => {
  //   setSpin(true);
  //   setCertificateImg({ file: event.target.files[0] });
  //   refselectedCertificateFile.current = event.target.files[0];
  //   console.log("image");
  //   handleimageUploadCertificate(event.target.files[0], item);
  // };

  // function handleimageUploadCertificate(imageGot, item) {
  //   if (imageGot == null) {
  //     return;
  //   }

  //   if (imageGot.size > 5242880) {
  //     swal1(
  //       "Oops!",
  //       "Image size is too large. File size cannot be greater than 5mb.",
  //       "error"
  //     );
  //     return;
  //   }
  //   if (imageGot !== undefined) {
  //     let uniqueStamp = new Date().getTime();
  //     let CertID = uniqueStamp + ".png";
  //     setCertificateFileName(uniqueStamp + ".png");

  //     var body = {
  //       type: "uploadCert",
  //       oid: config.aws_org_id,
  //       filetype: imageGot.type,
  //       filename: CertID,
  //     };

  //     console.log("bodyImg", body);
  //     uploadfileCertificate(body, imageGot, CertID, item);
  //   }
  // }

  // async function uploadfileCertificate(body, file, CertID, item) {
  //   //setIstLoading(true);
  //   const bodyParam = {
  //     body,
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "application/json",
  //     },
  //   };
  //   try {
  //     const preSignedData = await API.post(
  //       config.aws_cloud_logic_custom_name,
  //       Constants.GET_PRESIGNED_URL,
  //       /* "/getpreSignedURL", */
  //       bodyParam
  //     );

  //     axios
  //       .put(preSignedData, file, {
  //         headers: {
  //           "Content-Type": file.type,
  //           "Cache-Control": "no-cache no-store must-revalidate",
  //         },
  //       })
  //       .then((response) => {
  //         console.log("file upload success");
  //         uploadCertificate(CertID, item);
  //       })

  //       .catch((error) => {
  //         console.error("There was an error!", error);
  //       });

  //     //setIstLoading(false);
  //   } catch (error) {
  //     // alert(JSON.stringify(error));
  //     console.error(error);
  //   }
  // }
  function CopyOldAttendence(registeredUsersGot) {
    let temp = [];
    if (registeredUsersGot !== null) {
      if (registeredUsersGot !== undefined && registeredUsersGot.length > 0) {
        for (let i = 0; i < registeredUsersGot.length; i++) {
          if (registeredUsersGot[i].attend) {
            temp.push(registeredUsersGot[i].ur_id.toString());
          }
        }
      }
    }

    setNewArray(temp);
  }

  const handleClick = (event, item) => {
    let tempArray = [...newArray];
    if (tempArray.includes(item)) {
      var index = tempArray.indexOf(item);
      tempArray.splice(index, 1);
    } else {
      tempArray.push(item);
    }

    setNewArray(tempArray);
  };

  //   const handleClickMail = (event) => {

  //     console.log("button clicked---");
  //     setAttenSubmitted(event.target.checked);
  //   // let tempArray = [...newArray];
  //   // if (tempArray.includes(item)) {
  //   //   var index = tempArray.indexOf(item);
  //   //   tempArray.splice(index, 1);
  //   // } else {
  //   //   tempArray.push(item);
  //   // }
  //   // console.log("aten", tempArray);
  //   // setNewArray(tempArray);
  // };

  // async function uploadCertificate(CertID, item) {
  //   item.certid = CertID;
  //   const bodyParam = {
  //     body: {
  //       sessionID: listForReg.SID,
  //       uData: item,

  //       eid: item.eid,
  //       tenant: item.tenant,

  //       oid: config.aws_org_id,
  //     },
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "application/json",
  //     },
  //   };
  //   try {
  //     const upload = await API.post(
  //       config.aws_cloud_logic_custom_name,
  //       "/uploadCert",

  //       bodyParam
  //     );

  //     console.log("upload", upload);
  //     getRegisteredUsers();
  //     setSpin(false);
  //     swal
  //       .fire({
  //         title: "Success",
  //         text: "Uploaded successfully",
  //         icon: "success",
  //         dangerMode: false,
  //       })
  //       .then((willDelete) => {
  //         if (willDelete) {
  //           setSpin(false);
  //         }
  //       });
  //     //setIstLoading(false);
  //   } catch (error) {
  //     // alert(JSON.stringify(error));
  //     swal
  //       .fire({
  //         title: "Oooops!",
  //         text: "Soomthing wrong!",
  //         icon: "warning",
  //         dangerMode: true,
  //       })
  //       .then((willDelete) => {
  //         if (willDelete) {
  //           setSpin(false);
  //         }
  //       });
  //     console.error(error);
  //     setSpin(false);
  //   }
  // }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function markAttendance() {
    let unmark = [];
    for (let i = 0; i < registeredUsers.length; i++) {
      if (!newArray.includes(registeredUsers[i].ur_id.toString())) {
        unmark.push(registeredUsers[i].ur_id.toString());
      }
    }

    updateAttendence(unmark);
  }

  // function thankyouMail() {

  //   setShowModal(true);
  // }

  //   const closeModal = () => {
  //   setShowModal(false);
  // };

  const disableCheckBox = (item) => {
    // if (item?.date_list === undefined && item?.date_list == null) return false;

    if (item?.date_list && item?.date_list.length > 0) {
      if (
        new Date().getTime() >=
        new Date(
          item?.date_list[item?.date_list?.length - 1].combineEndTime,
        ).getTime()
      ) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  };
  const handleSave = async (i) => {
    let newArr = [];
    let upd_value = [...registeredUsers];
    upd_value?.forEach((value) => {
      if (value.actual_amount) {
        let obj = {};
        obj["amount"] = parseFloat(value?.actual_amount);
        obj["ur_id"] = value?.ur_id;
        newArr.push(obj);
      }
    });
    console.log(newArr);

    const bodyParam = {
      body: {
        type: "session",
        id: listForReg.sid,
        userJson: newArr,
        schema: "uspsm",
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      console.log("==", bodyParam);
      await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.UPDATE_ACTUAL_AMOUNT,
        bodyParam,
      );
      // setActualAmount(response.body);
      swal1("Success", "Amount Updated Successfully", "success");
      listSessions();
    } catch (error) {
      console.error(error);
    }
    setInputValue("");
  };

  const onlySidData = data.map((item) => ({
    sid: item.sid,
  }));

  const today = new Date().toLocaleDateString("en-GB").replace(/\//g, "-");

  const firstSid = onlySidData[0]?.sid || "";

  //const fileName = `registered-users-sid-${today}`;

  const fileName = `Registered-Users_${firstSid}_${today}`;

  return (
    <div className={Ap.maincontainer}>
      <BackDrop sx={{ color: "#fff" }} open={spin} className={Ap.backdrop}>
        <CircularProgress color="inherit" />
      </BackDrop>
      <div className={Ap.topbar}>
        <h3 className={Ap.header}>Registered Participants</h3>
        <Close className={Ap.closeicon} onClick={() => handleCloseList()} />
      </div>
      {userDetails.role !== "Manager" &&
        listForReg.startdate != null &&
        listForReg.date_list == null && (
          <div className={Ap.attendencediv}>
            {tenantoid === false ? (
              newArray.length === 0 ? (
                <div></div>
              ) : parseInt(listForReg.startdate) > new Date().getTime() ? (
                "Session not started"
              ) : (
                <div>
                  <button
                    className={Li.addbutton}
                    onClick={() => markAttendance()}
                  >
                    Submit Attendance
                  </button>
                </div>
              )
            ) : null}
          </div>
        )}
      {showButton ? (
        <div className={Ap.attendencediv}>
          <button className={Li.savebutton} onClick={handleSave}>
            Save
          </button>
        </div>
      ) : null}
      {userDetails.role !== "Manager" &&
        listForReg.date_list != null &&
        (listForReg.startdate == null || listForReg.startdate === "0") && (
          <div className={Ap.attendencediv}>
            {tenantoid === false ? (
              newArray.length === 0 ? (
                <div></div>
              ) : new Date(listForReg.date_list.combineStartTime).getTime() >
                new Date().getTime() ? (
                "Session not started"
              ) : (
                <div>
                  <button
                    className={Li.addbutton}
                    onClick={() => markAttendance()}
                  >
                    Submit Attendance
                  </button>
                </div>
              )
            ) : null}

            {selectedMailUsers.length > 0 && (
              <div className={Ap.attendencediv}>
                <button
                  className={Li.addbutton}
                  onClick={() => setShowModal(true)}
                >
                  Thank you mail
                </button>

                <ThankYouModal
                  open={showModal}
                  onClose={() => setShowModal(false)}
                  selectedUsers={selectedMailUsers}
                  setSelectedUsers={setSelectedMailUsers}
                />
              </div>
            )}

            <div className={Ap.attendencediv}>
              <button
                className={Li.addbutton}
                onClick={() => setRegisterShowModal(true)}
              >
                Register Users
              </button>

              {showRegisterShowModal && (
                <RegistersUsers
                  open={showRegisterShowModal}
                  onClose={() => setRegisterShowModal(false)}
                  getRegisteredUsers={getRegisteredUsers}
                  selectedUsers={selectedMailUsers}
                  setSelectedUsers={setSelectedMailUsers}
                  sid={listForReg.sid}
                />
              )}
            </div>

            <Button color="primary">
              <CSVLink
                data={data}
                headers={headers}
                filename={fileName}
                className={listTopStyle.exp_btn}
              >
                <FileDownload />
                Export
              </CSVLink>
            </Button>
          </div>
        )}

      <Dialog
        open={feedbackOpen}
        aria-labelledby="responsive-dialog-title"
        scroll="paper"
        maxWidth="lg"
      >
        <Feedback
          handleFeedBackClose={handleFeedBackClose}
          feedData={feedData}
        />
      </Dialog>
      {/* <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={feedbackOpen}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={feedbackOpen}>
          <Feedback
            setSpin={setSpin}
            spin={spin}
          />
        </Fade>
      </Modal> */}

      {/* <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={feedbackOpen}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={feedbackOpen}>
          <Feedback
            setSpin={setSpin}
            spin={spin}
          />
        </Fade>
      </Modal> */}
      <Table>
        <TableHead sx={{ background: "#285780" }}>
          <TableRow>
            <TableCell style={header}>
              <Checkbox
                checked={
                  registeredUsers.length > 0 &&
                  selectedMailUsers.length === registeredUsers.length
                }
                indeterminate={
                  selectedMailUsers.length > 0 &&
                  selectedMailUsers.length < registeredUsers.length
                }
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedMailUsers(
                      registeredUsers.map((u) => ({
                        ur_id: u.ur_id.toString(),
                        emailid: u.emailid,
                      })),
                    );
                  } else {
                    setSelectedMailUsers([]);
                  }
                }}
              />
            </TableCell>
            <TableCell style={header}>First Name</TableCell>
            <TableCell style={header}>Last Name</TableCell>
            <TableCell style={header}>Email</TableCell>
            {tenantoid === true ? (
              <TableCell style={header}>Feedback</TableCell>
            ) : null}

            {userDetails.role === "Manager" ? null : tenantoid === false ? (
              listForReg.paid === "false" ? null : (
                <TableCell style={header}>Invoice</TableCell>
              )
            ) : null}

            {tenantoid === false ? (
              listForReg.paid === "false" ? null : (
                <TableCell style={header}>Payment Method</TableCell>
              )
            ) : null}
            {tenantoid === false ? (
              <TableCell style={header}>Assigness</TableCell>
            ) : null}
            {userDetails.role === "Manager" ? null : tenantoid === false ? (
              <TableCell style={header}>Attendance</TableCell>
            ) : null}
            <TableCell style={header}>Certificate</TableCell>
            <TableCell style={header}>Actual Amount</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {(rowsPerPage > 0
            ? registeredUsers?.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
              )
            : registeredUsers
          )?.map((item, i) => (
            <TableRow>
              {/* {userDetails.role === "Manager" ? null : tenantoid === false ? ( */}
              <TableCell>
                {" "}
                {/* <FormControlLabel
                    label="gjh"
                    control={ */}
                <Checkbox
                  disabled={disableCheckBox(item)}
                  checked={selectedMailUsers.some(
                    (u) => u.ur_id === item.ur_id.toString(),
                  )}
                  onChange={(e) => {
                    const userObj = {
                      ur_id: item.ur_id.toString(),
                      emailid: item.emailid,
                    };

                    setSelectedMailUsers((prev) =>
                      e.target.checked
                        ? [...prev, userObj]
                        : prev.filter((u) => u.ur_id !== userObj.ur_id),
                    );
                  }}
                />
                {/*  }
                  /> */}
              </TableCell>
              {/* ) : null} */}
              <TableCell>{item?.first_name}</TableCell>
              <TableCell>{item?.last_name}</TableCell>
              <TableCell>{item?.emailid}</TableCell>
              {tenantoid === true ? (
                <TableCell>
                  {item?.fbstatus || item?.feedback ? (
                    <h3 style={{ fontSize: "14px", fontWeight: "300" }}>
                      No Feedback
                    </h3>
                  ) : (
                    <button
                      onClick={() => handleFeedBackOpen(item)}
                      className={Ap.feedbackbutton}
                    >
                      View Feedback
                    </button>
                  )}
                </TableCell>
              ) : null}

              {userDetails.role === "Manager" ? null : tenantoid === false ? (
                listForReg.paid === "false" ? null : item?.inid === undefined ||
                  item?.inid === null ? (
                  <TableCell>
                    <div>
                      <button
                        className={Li.addbutton}
                        onClick={() => {
                          handleOpenProforma(item);
                        }}
                      >
                        Update Invoice
                      </button>
                      {/* <span className={Li.addbutton}>
                          Upload PDF{item.ur_id}
                        </span> */}
                      <h5>
                        {/* {" "}
                        {invoiceimg !== null && invoiceimg.file !== undefined
                          ? invoiceimg.file.name
                          : ""} */}
                      </h5>
                    </div>
                  </TableCell>
                ) : (
                  <TableCell>
                    {item.invoice_dtls === null ? (
                      <div>
                        <div>
                          <button
                            className={Li.addbutton}
                            onClick={() => handleViewClick(item)}
                            style={{
                              marginTop: "10px",
                              marginBottom: "10px",
                            }}
                          >
                            View
                          </button>
                        </div>
                        <div>
                          <span>To Reupload </span>
                          <input
                            accept=".pdf"
                            //id="contained-button-fileRe"

                            multiple
                            type="file"
                            //className={Li.addbutton}
                            onChange={(e) => handleimageRE(e, item)}
                          />
                        </div>
                      </div>
                    ) : (
                      <div>
                        <button
                          className={Li.addbutton}
                          onClick={() => {
                            handleOpenProforma(item);
                          }}
                        >
                          Update Invoice
                        </button>
                      </div>
                    )}
                  </TableCell>
                )
              ) : null}

              {tenantoid === false ? (
                listForReg.paid === "false" ? null : (
                  <TableCell>
                    {item.pstatus === 0 ? "NEFT" : null}
                    {item.pstatus === 1 ? "RazorPay" : null}
                    {item.pstatus === 2 ? "Pay Later" : null}{" "}
                    {item.pstatus === 10 ? "Payment in process" : null}
                  </TableCell>
                )
              ) : null}
              {tenantoid === false ? (
                <TableCell>{item.assign}</TableCell>
              ) : null}
              {userDetails.role === "Manager" ? null : tenantoid === false ? (
                <TableCell>
                  {" "}
                  {/* <FormControlLabel
                    label="gjh"
                    control={ */}
                  <Checkbox
                    disabled={disableCheckBox(item)}
                    checked={newArray.includes(item.ur_id.toString())}
                    onChange={(e) => handleClick(e, item.ur_id.toString())}
                  />
                  {/*  }
                  /> */}
                </TableCell>
              ) : null}

              {/* {item.certid === undefined ? (
                  <TableCell>
                    <label htmlFor="contained-button-file">
                      <Input
                        accept="image/*"
                        id="contained-button-file"
                        multiple
                        type="file"
                        onChange={(e) => handleimageCertificate(e, item)}
                      />
                      <Button
                        sx={{
                          color: "#ff6f4d",
                          border: "2px solid #ff6f4d",
                          "&:hover": {
                            border: "2px solid #ff6f4d",
                          },
                        }}
                        className={Ap.upload}
                        //variant="outlined"
                        component="span"
                      >
                        Upload Certificate
                      </Button>
                      <h5>
                        {" "}
                        {certificateimg !== null &&
                        certificateimg.file !== undefined
                          ? certificateimg.file.name
                          : ""}
                      </h5>
                    </label>
                  </TableCell>
                ) : (
                  <Button
                    sx={{
                      color: "#ff6f4d",
                      border: "2px solid #ff6f4d",
                      "&:hover": {
                        border: "2px solid #ff6f4d",
                      },
                    }}
                    style={{ height: "30px", marginTop: "10px" }}
                    //className={Ap.upload}
                    onClick={() => handleViewClickCertificate(item)}
                    //variant="outlined"
                    //component="span"
                  >
                    View
                  </Button>
                )} */}
              {item.aprstatus === 1 &&
              item.attend &&
              (item.fbstatus || item?.feedback) ? (
                // item.certid != null
                <TableCell>
                  <button
                    className={Li.addbutton}
                    onClick={() => {
                      handleClickCertificateOpen(item);
                    }}
                  >
                    View certificate
                  </button>
                </TableCell>
              ) : (
                <TableCell>
                  <p>No certificates yet</p>
                </TableCell>
              )}
              <TableCell>
                <Box sx={{ width: 350 }}>
                  {/* <TextField
                    type="number"
                    value={
                      item?.actual_amount
                        ?.replace(/[^0-9.]/g, "")
                        ?.replace(/(\..*)\./g, "$1") || ""
                    }
                    onChange={(e) => {
                      let copyRegisteredUsers = [...registeredUsers];
                      copyRegisteredUsers[i].actual_amount = e.target.value;
                      copyRegisteredUsers[i].updated_amount = true;
                      setRegisteredUsers(copyRegisteredUsers);
                      setShowButton(true);
                    }}
                  /> */}
                  {`${item.invoice_dtls?.unit || ""} ${
                    item.actual_amount || ""
                  }`}
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>

        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
              colSpan={tenantoid === true ? 5 : 7}
              count={registeredUsers?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableRow>
        </TableFooter>
      </Table>
      <Dialog
        fullScreen={Ap.fullScreen}
        open={invoiceOpen}
        aria-labelledby="responsive-dialog-title-2"
        maxWidth="md"
      >
        <div style={{ padding: "20px" }}>
          <Close
            className={Ap.closeicon}
            style={{ float: "right" }}
            onClick={() => setInvoiceOpen(false)}
          />
          <h5>Invoice - {viewingState.first_name} </h5>
          <iframe
            style={{
              width: "750px",
              height: "800px",
              borderRadius: "10px",
            }}
            src={`https://${
              config.DOMAIN
            }/${config.aws_org_id.toLowerCase()}-resources/documents/invoices/${
              viewingState.inid
            }`}
            height="100%"
            width="100%"
            title="pdfView"
          />
          {/* <img
            style={{
              width: "650px",
              height: "800px",
              borderRadius: "10px",
            }}
            src={`https://${
              config.DOMAIN
            }/${config.aws_org_id.toLowerCase()}-resources/documents/invoices/${
              viewingState.inid
            }`}
            alt=""
          ></img> */}
        </div>
      </Dialog>
      {/*  <Dialog
        fullScreen={fullScreen}
        open={certificateOpen}
        aria-labelledby="responsive-dialog-title-2"
        maxWidth="md"
      >
        <div style={{ padding: "20px" }}>
          <Close
            className={Ap.closeicon}
            style={{ float: "right" }}
            onClick={() => setCertificateOpen(false)}
          />
          <h5>Invoice - {viewingStatecertificate.email}</h5>
          <img
            style={{
              width: "650px",
              height: "800px",
              borderRadius: "10px",
            }}
            src={`https://${
              config.DOMAIN
            }/${config.aws_org_id.toLowerCase()}-resources/documents/certificates/${
              viewingStatecertificate.certid
            }`}
            alt=""
          ></img>
        </div>
      </Dialog> */}
      {/*  <Dialog
        fullScreen={fullScreen}
        open={certificateOpen}
        aria-labelledby="responsive-dialog-title-2"
        maxWidth="md"
      > */}
      <div style={{ padding: "20px" }}>
        <CertificatePopUp
          open={certificateOpen}
          setOpen={setCertificateOpen}
          details={userDetailsReg}
          sData={listForReg}
        />
      </div>
      {/* 
      <ProformaEdit
        handleCloseProformaEdit={handleCloseProformaEdit}
        open={openProformaEdit}
      /> */}
      <ProInvoice
        handleCloseProforma={handleCloseProforma}
        open={openProforma}
        openProformaEdit={openProformaEdit}
        listForReg={listForReg}
        userInvoiceData={userInvoiceData}
        // setActualAmt={setActualAmt}
        //setActualAmtUnit={setActualAmtUnit}
        getRegisteredUsers={getRegisteredUsers}
      />
      {/*  )} */}
      {/*  </Dialog> */}
    </div>
  );
}
